const isMargiela = document.querySelector('body').classList.contains('Margiela');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
const appendToUrl = (url, params) => {
  let newUrl = url;
  newUrl +=
    (newUrl.indexOf('?') !== -1 ? '&' : '?') +
    Object.keys(params)
      .map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
      })
      .join('&');

  return newUrl;
};

/**
 * Get store icon based on type
 * @param {bool} isOutlet - outlet type
 * @returns {Object} Google Maps friendly marker
 */
const getMarkerIcon = (isOutlet, detailPage, isSingleStore) => {
  let outletMarker;
  let storeMarker;
  let storeDetailMarker;
  
  if(isMargiela){
    outletMarker = window.sfcc_urls.static + '/images/storelocator/map-marker.svg';
    storeMarker = window.sfcc_urls.static + '/images/storelocator/map-marker.svg';
    storeDetailMarker = window.sfcc_urls.static + '/images/storelocator/map-marker-selected.svg';
  } else {
   outletMarker = window.sfcc_urls.static + '/images/storelocator/store_marker.svg';
   storeMarker = window.sfcc_urls.static + '/images/storelocator/store_marker.svg';
   storeDetailMarker = window.sfcc_urls.static + '/images/storelocator/store_marker_fill.svg';
  }
  let markerUrl = isOutlet ? outletMarker : storeMarker;
  if (detailPage || isSingleStore) {
    markerUrl = storeDetailMarker;
  }
  return {
    url: markerUrl,
    scaledSize: new google.maps.Size(32, 44),
    anchor: new google.maps.Point(13, 30),
    labelOrigin: new google.maps.Point(16, 16),
  };
};

/**
 * Add Marker to map
 * @param {bool} map - map object
 * @param {Object} prop - marker properties
 * @param {Object} label - marker properties
 * @param {boolean} detailPage - detail page
 * @returns {Object} Google Maps friendly marker
 */
const buildMarker = (map, prop, label, detailPage, isSingleStore) => {
  const markerObj = {
    position: new google.maps.LatLng(prop.latitude, prop.longitude),
    map: map,
    icon: getMarkerIcon(prop.isOutlet, detailPage, isSingleStore),
  };

  if (!detailPage) {
    if(isMargiela){
      markerObj.label = { text: label.toString(), color: 'white', fontSize: '12px', fontWeight: '500', fontFamily: 'Margiela Sans' };
    } else {
    markerObj.label = { text: label.toString(), color: 'black', fontSize: '14px', fontWeight: 'normal', fontFamily: 'Futura' };
    }
  }

  return new google.maps.Marker(markerObj);
};

const getBoundariesCoords = (map) => {
  const b = map.getBounds();
  const southWestPoint = b.getSouthWest();
  const northEastPoint = b.getNorthEast();

  return {
    latmin: southWestPoint.lat(),
    latmax: northEastPoint.lat(),
    lngmin: southWestPoint.lng(),
    lngmax: northEastPoint.lng(),
  };
};

const mq = () => {
  if(isMargiela){
    return window.matchMedia('(max-width: 1023.98px)').matches;
  } else {
    return window.matchMedia('(max-width: 991.98px)').matches;
  }
};

module.exports = {
  appendToUrl,
  buildMarker,
  getBoundariesCoords,
  mq,
};
